<template>
  <div
    class="ticket-menu"
    :style="{top, left}"
  >
    <div
      v-for="(action, idx) in actions"
      :key="idx"
      class="ticket-menu-link"
      :class="{'is--disabled': isDisabled(action)}"
      @click="callAction(action)"
    >
      <i class="ri-barcode-box-line" />
      {{ 'd_ws_context_' + action | translate }}
    </div>
  </div>
</template>

<script>
import {CONTEXT_MENU_ACTIONS} from "@/components/devices/OperatorWorkspace/config";

export default {
  props: ['top', 'left', 'actions'],
  computed: {
    contextMenuAccess() {
      return !this.$store.currentTicket && !this.$store.currentTicketServicing
    }
  },
  methods: {
    callAction(action) {
      this.$emit(action, this.contextMenuAccess)
    },
    isDisabled(action) {
      if (action === CONTEXT_MENU_ACTIONS.ISSUED) return false;

      return !this.contextMenuAccess;
    }
  }
}
</script>

<style lang="scss" scoped>
  .ticket-menu {
    position: absolute;
    width: 180px;
    box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.08), 0px 7.7037px 19.1111px rgba(0, 0, 0, 0.0485926), 0px 1.62963px 4.88889px rgba(0, 0, 0, 0.0314074);
    border-radius: 6px;
    background: var(--light-01);
    border: 1px solid var(--accent-blue);
    &-link {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 0;
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      cursor: pointer;
      color: var(--accent-blue);
      border-bottom: 1px solid var(--accent-blue);
      &.is--disabled {
        background: var(--disabled-24);
        color: var(--label-tetriary);
        cursor: default;
      }
      &:last-child {
        border-bottom: 0;
      }
      i {
        font-weight: normal;
        font-size: 20px;
        margin-right: 4px;
      }
    }
  }
</style>
